import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BreadCrumb } from '../../interfaces/breadcrumb.interface';
import * as translate from "translate";
import { filter, map } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { wordsWithHyphens } from './data/words-with-hyphens'

@Component({
  selector: 'mono-common-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  readonly defaultLanguage = "en";

  @Input() public language?: string = this.defaultLanguage;

  public urlNameAndSegments: BreadCrumb[] = [];
  public homeText: Observable<string>;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.homeText = from(translate(this.language == this.defaultLanguage ? "Home" : "Home page", this.language))
    .pipe(map((homeText: string) => homeText[0].toUpperCase() + homeText.slice(1)));
    this.urlNameAndSegments = this.createUrlObject(this.createUrlSegments(this.router.url));
    this.router.events.pipe(
      filter(event => (event instanceof NavigationEnd))).subscribe((event: NavigationEnd) => {
        this.urlNameAndSegments = this.createUrlObject(this.createUrlSegments(event.url));
    });
  }

  private createUrlSegments(url: string): string[] {
    return url.split(/[?#]/)[0].split("/").filter(i => i);
  }

  private createUrlObject(routeSnapshotUrls): BreadCrumb[] {
    if (routeSnapshotUrls.length) {
      return routeSnapshotUrls.map((url, urlIndex) => ({ urlName: this.removeHyphens(url), urlSegment: this.createUrl(routeSnapshotUrls, urlIndex) }))
    }
  };
  private createUrl(urls, urlIndex): string {
    const filteredUrls = urls.slice(0, urlIndex + 1)
    const path = filteredUrls.map(url => url).join('/');
    return path;
  };

  private removeHyphens(linkName): string {
    let nameWithoutHyphens = linkName.replace(/-/g, ' ');
    nameWithoutHyphens = this.addHyphensForSpecificWords(nameWithoutHyphens, wordsWithHyphens);
    return nameWithoutHyphens[0].toUpperCase() + nameWithoutHyphens.slice(1)
  }

  private addHyphensForSpecificWords(text: string, wordMap): string {
    let corrected = text;
    for (const [key, value] of Object.entries<string>(wordMap)) {
      corrected = corrected.replace(new RegExp(key, 'ig'), value);
    }

    return corrected;
  }
}
